var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9998 8.00008C18.745 8.00008 7.99984 18.7452 7.99984 32.0001C7.99984 45.2549 18.745 56.0001 31.9998 56.0001C45.2547 56.0001 55.9998 45.2549 55.9998 32.0001C55.9998 18.7452 45.2547 8.00008 31.9998 8.00008ZM2.6665 32.0001C2.6665 15.7997 15.7995 2.66675 31.9998 2.66675C48.2002 2.66675 61.3332 15.7997 61.3332 32.0001C61.3332 48.2004 48.2002 61.3334 31.9998 61.3334C15.7995 61.3334 2.6665 48.2004 2.6665 32.0001ZM31.9998 18.6667C33.4726 18.6667 34.6665 19.8607 34.6665 21.3334V32.0001C34.6665 33.4728 33.4726 34.6667 31.9998 34.6667C30.5271 34.6667 29.3332 33.4728 29.3332 32.0001V21.3334C29.3332 19.8607 30.5271 18.6667 31.9998 18.6667ZM31.9998 40.0001C30.5271 40.0001 29.3332 41.194 29.3332 42.6667C29.3332 44.1395 30.5271 45.3334 31.9998 45.3334H32.0265C33.4993 45.3334 34.6932 44.1395 34.6932 42.6667C34.6932 41.194 33.4993 40.0001 32.0265 40.0001H31.9998Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.1f2018f56bee43b1189ee5c9a42d4234.svg";
export { ForwardRef as ReactComponent };